import React from 'react';
import { FaUserCircle, FaBuilding, FaArrowRight, FaHandshake, FaChartLine } from 'react-icons/fa';

export default function NetworkGraph() {
  return (
    <div className="h-[600px] bg-gradient-to-br from-blue-50 to-white rounded-lg shadow-lg p-8">
      {/* Main Infographic Container */}
      <div className="h-full flex flex-col items-center justify-center">
        {/* Title */}
        <h3 className="text-2xl font-bold text-gray-800 mb-8">How 6degrees.ai Works</h3>
        
        {/* Process Flow */}
        <div className="flex items-center justify-between w-full max-w-4xl mb-12">
          {/* Step 1: Your Network */}
          <div className="flex flex-col items-center w-64">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-4">
              <FaUserCircle className="w-8 h-8 text-blue-600" />
            </div>
            <h4 className="font-semibold text-gray-700 mb-2">Connect Your CRM</h4>
            <p className="text-sm text-gray-600 text-center">Integrate with your existing CRM system in just a few clicks</p>
          </div>

          <FaArrowRight className="text-blue-400 w-6 h-6" />

          {/* Step 2: AI Analysis */}
          <div className="flex flex-col items-center w-64">
            <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mb-4">
              <FaChartLine className="w-8 h-8 text-purple-600" />
            </div>
            <h4 className="font-semibold text-gray-700 mb-2">Identify Referral Partners</h4>
            <p className="text-sm text-gray-600 text-center">Discover potential referrers among your customers, investors, friends, and colleagues</p>
          </div>

          <FaArrowRight className="text-blue-400 w-6 h-6" />

          {/* Step 3: Warm Introductions */}
          <div className="flex flex-col items-center w-64">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4">
              <FaHandshake className="w-8 h-8 text-green-600" />
            </div>
            <h4 className="font-semibold text-gray-700 mb-2">View Connections in your CRM</h4>
            <p className="text-sm text-gray-600 text-center">See who in your team's network can introduce you to key decision-makers</p>
          </div>
        </div>

        {/* Results Section */}
        <div className="bg-white rounded-xl shadow-sm p-6 w-full max-w-4xl">
          <div className="flex justify-around">
            <div className="text-center">
              <div className="text-3xl font-bold text-blue-600 mb-2">8x</div>
              <div className="text-sm text-gray-600">More Warm Introductions</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-blue-600 mb-2">50%</div>
              <div className="text-sm text-gray-600">Higher Response Rate</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-blue-600 mb-2">2x</div>
              <div className="text-sm text-gray-600">Faster Deal Closure</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}